import React from 'react';
import InboxItemCard from './InboxItemCard';

/**
 * InboxTimelineGroup Component
 * Displays a temporal section (Today, Yesterday, Earlier This Week, etc.) with group-level actions.
 */
export default function InboxTimelineGroup({
    groupTitle,
    items = [],
    selectedIds = new Set(),
    onToggleSelect,
    onToggleBookmark,
    onToggleArchive,
    onToggleRead,
    onMarkGroupAsRead,
    onActionClick,
}) {
    if (items.length === 0) return null;

    const allGroupSelected = items.every((item) => selectedIds.has(item.id));
    const unreadCount = items.filter((item) => !item.read).length;

    const handleSelectAllGroup = () => {
        const itemIds = items.map((i) => i.id);
        onToggleSelect?.(itemIds, !allGroupSelected);
    };

    return (
        <div className="space-y-3 pt-2 timeline-group">
            {/* Group Header */}
            <div className="flex items-center justify-between px-1">
                <div className="flex items-center gap-2.5">
                    <input
                        type="checkbox"
                        checked={allGroupSelected}
                        onChange={handleSelectAllGroup}
                        className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                    />
                    <h2 className="font-headline font-bold text-sm text-[#003263] dark:text-[#a7c8ff] uppercase tracking-wider">
                        {groupTitle}
                    </h2>
                    {unreadCount > 0 ? (
                        <span className="bg-blue-100/60 dark:bg-blue-950/60 text-[#03488A] dark:text-[#00AAF1] text-[10px] font-bold px-2 py-0.5 rounded-full border border-blue-200/50 dark:border-blue-800/60">
                            {unreadCount} new {unreadCount === 1 ? 'event' : 'events'}
                        </span>
                    ) : (
                        <span className="bg-slate-100 dark:bg-[#252525] text-slate-600 dark:text-slate-400 text-[10px] font-bold px-2 py-0.5 rounded-full">
                            {items.length} {items.length === 1 ? 'event' : 'events'}
                        </span>
                    )}
                </div>

                {unreadCount > 0 && (
                    <button
                        onClick={() => onMarkGroupAsRead?.(items.map((i) => i.id))}
                        className="text-xs text-slate-400 dark:text-slate-500 hover:text-blue-700 dark:hover:text-[#00AAF1] transition-all font-medium cursor-pointer"
                    >
                        Mark group as read
                    </button>
                )}
            </div>

            {/* List of Item Cards in this group */}
            <div className="space-y-3">
                {items.map((item) => (
                    <InboxItemCard
                        key={item.id}
                        item={item}
                        isSelected={selectedIds.has(item.id)}
                        onToggleSelect={onToggleSelect}
                        onToggleBookmark={onToggleBookmark}
                        onToggleArchive={onToggleArchive}
                        onToggleRead={onToggleRead}
                        onActionClick={onActionClick}
                    />
                ))}
            </div>
        </div>
    );
}
